/* user/reducer */
import { createReducer } from "typesafe-actions";
import { UserActionTypes, UserState } from "./types";
import {
  fetchPermission,
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";

export const initialState: UserState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchPermission>
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<UserState, ActionType>(initialState)
  .handleType(UserActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
    .handleType(UserActionTypes.FETCH_PERMISSION, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(UserActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(UserActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(UserActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(UserActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(UserActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      data: undefined,
    };
  })
  .handleType(UserActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(UserActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(UserActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
